import { render, staticRenderFns } from "./BaseNotificationContainer.vue?vue&type=template&id=5094912f&scoped=true"
import script from "./BaseNotificationContainer.vue?vue&type=script&lang=js"
export * from "./BaseNotificationContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseNotificationContainer.vue?vue&type=style&index=0&id=5094912f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094912f",
  null
  
)

export default component.exports